import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "Home" */ './views/Home.vue')
    },
    {
      path: '/profile/:user',
      name: 'profile',
      component: () => import(/* webpackChunkName: "Profile" */ './views/Profile.vue')
    },
    {
      path: '/post/:post_id',
      name: 'post_detail',
      component: () => import(/* webpackChunkName: "PostDetail" */ './views/PostDetail.vue')
    },    
    {
      path: '/mobilepost/:post_id',
      name: 'mobilepost_detail',
      component: () => import(/* webpackChunkName: "PostDetail" */ './views/mobile/PostDetail.vue')
    },
    {
      path: '/mobilecommunity',
      name: 'mobile_community',
      component:() => import('./views/mobile/MobileCommunity.vue')
    },
    {
      path: '/message',
      name: 'message',
      component: () => import(/* webpackChunkName: "Message" */ './views/Message.vue'),
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "CommentMessage" */ './views/CommentMessage')
        },
        {
          path: 'comment',
          name: 'comment',
          component: () => import(/* webpackChunkName: "CommentMessage" */ './views/CommentMessage')
        },
        {
          path: 'like',
          name: 'like',
          component: () => import(/* webpackChunkName: "LikeMessage" */ './views/LikeMessage')
        },
        {
          path: 'notification',
          name: 'notification',
          component: () => import(/* webpackChunkName: "NotificationMessage" */ './views/NotificationMessage')
        },
        {
          path: 'attention',
          name: 'attention',
          component: () => import(/* webpackChunkName: "AttentionMessage" */ './views/AttentionMessage')
        }
      ]
    },    
    {
      path: '/mobilemessage',
      name: 'mobilemessage',
      component: () => import(/* webpackChunkName: "MoblieMessage" */ './views/mobile/MobileMessage.vue'),
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "MoblieCommentMessage" */ './views/mobile/MoblieCommentMessage')
        },
        {
          path: 'comment',
          name: 'comment',
          component: () => import(/* webpackChunkName: "MoblieCommentMessage" */ './views/mobile/MoblieCommentMessage')
        },
        {
          path: 'like',
          name: 'like',
          component: () => import(/* webpackChunkName: "MoblieLikeMessage" */ './views/mobile/MoblieLikeMessage')
        },
        {
          path: 'notification',
          name: 'notification',
          component: () => import(/* webpackChunkName: "MoblieNotificationMessage" */ './views/mobile/MoblieNotificationMessage')
        },
        {
          path: 'attention',
          name: 'attention',
          component: () => import(/* webpackChunkName: "MoblieAttentionMessage" */ './views/mobile/MoblieAttentionMessage')
        }
      ]
    },
    {
      path: '/company/:company_id',
      name: 'company_detail',
      component: () => import(/* webpackChunkName: "DetailCompany" */ './views/DetailCompany.vue')
    },
    {
      path:'/company/type/:grade_id',
      name:'company_type',
      component:() => import(/* webpackChunkName: "DetailCompanyType" */ './views/DetailCompanyType.vue')
    },
    {
      path:'/company_product/detail',
      name:'company_product',
      component:() => import(/* webpackChunkName: "DetailCompanyProduct" */ './views/DetailCompanyProduct.vue')
    },
    {
      path: '/myfollower',
      name: 'myfollower',
      component: () => import(/* webpackChunkName: "MyFollower" */ './views/MyFollower.vue')
    },
    {
      path:'/scratch/allworkscontainer',
      name:'scratch_allwork',
      component: () => import(/* webpackChunkName: "ScratchAllWorksContainer" */ './views/scratch/components/ScratchAllWorksContainer.vue')
    },
    {
      path: '/videoCourse/:category_id',
      name: 'video_course',
      component: () => import(/* webpackChunkName: "VideoCourse" */ './views/scratch/VideoCourse.vue')
    },
    {
      path: '/works',
      name: 'works',
      component: () => import(/* webpackChunkName: "Works" */ './views/scratch/Works.vue')
    },
    {
      path: '/ActivityDetail/:number',
      name: 'activity_detail',
      component: () => import(/* webpackChunkName: "ActivityDetail" */ './views/activity/ActivityDetail.vue')
    },
    {
      path: '/ActivityApply/:number',
      name: 'activity_apply',
      component: () => import(/* webpackChunkName: "ActivityApply" */ './views/activity/ActivityApply.vue')
    },
    {
      path: '/school/:school_id',
      name: 'school_detail',
      component: () => import(/* webpackChunkName: "SchoolDetail" */ './views/school/SchoolDetail.vue')
    },
    {
      path: '/MyUpLoadFile/',
      name: 'my_up_load_file',
      component: () => import('./views/MyUpLoadFile.vue')
    },

    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
